export default () =>
  import(
    /* webpackChunkName: 'coffee/activities/invite-register' */ './InviteRegister'
  );
